import SubcribeForm from "@/components/Contact/SubcribeForm";
import urls from "@/utils/urls/urls";
import Link from "next/link";

export default async function Footer() {
  const resFooter = await fetch(urls?.footer);
  const dataFooter = await resFooter.json();
  const footerData = dataFooter?.data[0];
  // console.log("footerData", footerData)

  const res = await fetch(urls?.product);
  const data = await res.json();
  const products = Array.isArray(data?.data) ? data?.data : [];
  // cl("Products", products);

  const products1 = products?.slice(0, 7);
  const emails = await footerData?.email?.split(",");
  // console.log("emails", emails);

  return (
    <>
      <footer className="footer-area ">
        <div className="footer-shape">
          <img src="assets/img/shape/08.png" alt="" />
        </div>
        <div className="footer-widget">
          <div className="container">
            <div className="footer-widget-wrap pt-100 pb-80">
              <div className="row g-4">
                <div className="col-lg-5">
                  <div className="footer-widget-box about-us">
                    <Link href="/" className="footer-logo">
                      <img src={`${urls?.image}${footerData?.logo}`} alt="" />
                    </Link>
                    <p className="mb-4">{footerData?.description}</p>
                    <div className="footer-newsletter">
                      <h6>Subscribe Our Newsletter</h6>
                      <div className="newsletter-form">
                        <SubcribeForm />
                      </div>
                      <div>
                        {footerData?.qrcode ? (
                          <img
                            src={`${urls?.image}${footerData?.qrcode}`}
                            // src="assets/img/qr/qr_texexcellance.com.png"
                            alt=""
                            className=""
                            style={{
                              zIndex: "99",
                              width: "100px",
                            }}
                          />
                        ) : (
                          <img
                            // src={`${urls?.image}${footerData?.qrcode}`}
                            src="assets/img/qr/qr_texexcellance.com.png"
                            alt=""
                            className=""
                            style={{
                              zIndex: "99",
                              width: "100px",
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-lg-2">
                  <div className="footer-widget-box list">
                    <h4 className="footer-widget-title">Quick Links</h4>
                    <ul className="footer-list">
                      {footerData?.quick_links?.map(
                        (qlink: any, index: any) => (
                          <li key={index}>
                            <Link
                              href={qlink?.link}
                              className="text-gray-400 hover:text-white"
                            >
                              <i className="far fa-angle-double-right" />
                              {qlink?.title}
                            </Link>
                          </li>
                        ),
                      )}
                      {/* <li>
                                                <Link href={'/album'} className="text-gray-400 hover:text-white">
                                                    <i className="far fa-angle-double-right" />
                                                    Album
                                                </Link>
                                            </li> */}
                      {/* <li>
                                                <Link href="/about">
                                                    <i className="far fa-angle-double-right" />
                                                    About Us
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/about">
                                                    <i className="far fa-angle-double-right" />
                                                    Update News
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/about">
                                                    <i className="far fa-angle-double-right" />
                                                    Testimonials
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/contact">
                                                    <i className="far fa-angle-double-right" />
                                                    Contact Us
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/about">
                                                    <i className="far fa-angle-double-right" />
                                                    Terms Of Service
                                                </Link>
                                            </li>
                                            <li>
                                                <Link href="/about">
                                                    <i className="far fa-angle-double-right" />
                                                    Privacy policy
                                                </Link>
                                            </li> */}
                    </ul>
                  </div>
                </div>
                <div className="col-6 col-lg-2">
                  <div className="footer-widget-box list">
                    <h4 className="footer-widget-title">Products</h4>
                    <ul className="footer-list">
                      {products1
                        ?.filter(
                          (prod: any) =>
                            prod?.name != "" && prod?.featured == 1,
                        )
                        ?.map((prod: any) => (
                          <li key={prod?.id}>
                            <Link href="/products">
                              <i className="far fa-angle-double-right" />
                              {prod?.name}
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3">
                  <div className="footer-widget-box">
                    <h4 className="footer-widget-title">Get In Touch</h4>
                    <ul className="footer-contact">
                      <li>
                        <div className="icon">
                          <i className="far fa-location-dot" />
                        </div>
                        <div className="content">
                          <h6>Our Address</h6>
                          <p>{footerData?.address}</p>
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="far fa-phone" />
                        </div>
                        <div className="content">
                          <h6>Call Us</h6>
                          <Link href={`tel:${footerData?.mobile}`}>
                            {footerData?.mobile}
                          </Link>
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="far fa-envelope" />
                        </div>
                        <div className="content">
                          <h6>Mail Us</h6>
                          {emails?.map((email: string, i: number) => (
                            <Link href={`mailto:${email}`} key={i}>
                              {email}
                            </Link>
                          ))}

                          {/* <Link href="#">haroon.textile@gmail.com</Link> */}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="copyright">
            <div className="row">
              <div className="col-md-6 align-self-center">
                <div className="copyright-text">
                  {/* © Copyright <span id="date" />{" "} */}
                  {/* <Link href="#"> DHAKA APPS LIMITED </Link> All Rights Reserved. */}
                  {footerData?.copyright && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: footerData?.copyright,
                      }}
                    />
                  )}
                </div>
              </div>
              <div className="col-md-6 align-self-center">
                <ul className="footer-social">
                  {footerData?.social_icons &&
                    footerData?.social_icons?.map((icon: any, index: any) => (
                      <li key={index}>
                        <Link href={icon?.link} target="_blank">
                          <i className={`${icon?.icon}`}></i>
                        </Link>
                      </li>
                    ))}
                  {/* <li>
                                        <Link href="#">
                                            <i className="fab fa-facebook-f" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link href="#">
                                            <i className="fab fa-x-twitter" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link href="#">
                                            <i className="fab fa-linkedin-in" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link href="#">
                                            <i className="fab fa-youtube" />
                                        </Link>
                                    </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
